export default __webpack_public_path__ + "static/media/img_mobile_affliate_bg2.01371630.png";